import { Component } from '@angular/core';
import {
  LocalPersistenceService,
  MembersHeaderButton
} from 'src/shared-app-portal/services/local-persistence.service';

@Component({
  selector: 'app-members-header-controls',
  templateUrl: './members-header-controls.component.html',
  styleUrls: ['./members-header-controls.component.scss'],
  standalone: false
})
export class MembersHeaderControlsComponent {
  button: MembersHeaderButton;

  constructor(private localPersistenceService: LocalPersistenceService) {
    this.localPersistenceService.buttonSubject.subscribe((b) => this.updateButton(b));
  }

  private updateButton(button: MembersHeaderButton): void {
    this.button = button;
  }
}
